import { Dispatch } from "redux";

import { makeRequest } from "../util";
import {
  ConfiguredObjectSource,
  LOAD_CONFIGURED_OBJECT_SOURCES,
  SET_OBJECT_SOURCES_LOADING,
} from "../reducers/objectSources";

export const fetchObjectSources = () => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: SET_OBJECT_SOURCES_LOADING });

    const response = await makeRequest<{
      objectSources: ConfiguredObjectSource[];
    }>("object_source_data", {});

    dispatch({
      type: LOAD_CONFIGURED_OBJECT_SOURCES,
      payload: response.data.objectSources,
    });
  };
};
